import React from 'react';
import styles from './Layers.module.scss'
import ImageWrapper from "components/imageWrapper/ImageWrapper";

const ExtraBackGround = (props) => {

    function buildExtraBackGround(){
        if(props.macro === 'martellus'){
            return (
                <>
                    <div className={styles.bgChildWrapper}>
                        <div className={`${styles.bgLayer} ${styles.martellus_extraRainLft}`}>
                            <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-extra-rain-left.png'}} alt={'Rain left'}/>
                        </div>
                        <div className={`${styles.bgLayer} ${styles.martellus_extraRainRt}`}>
                            <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-extra-rain-right.png'}} alt={'Rain right'}/>
                        </div>
                        <div className={`${styles.bgLayer} ${styles.martellus_extraCloudTopRt}`}>
                            <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-extra-cloud-top-right.png'}} alt={'Cloud top right'}/>
                        </div>
                        <div className={`${styles.bgLayer} ${styles.martellus_extraCloudMidLft}`}>
                            <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-extra-cloud-med-left.png'}} alt={'Cloud mid left'}/>
                        </div>
                        <div className={`${styles.bgLayer} ${styles.martellus_extraCloudBtmRt}`}>
                            <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-extra-cloud-bottom-right-DUPE.png'}} alt={'Cloud bottom right'}/>
                        </div>
                        <div className={`${styles.bgLayer} ${styles.martellus_bonusFlowerHill}`} >
                            <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-flower-hill.png'}} alt={'Flower Hill'}/>
                        </div>
                    </div>
                </>
            )
        }

        else  return '';
    }

    return buildExtraBackGround()
};

export default ExtraBackGround
